function SectionHeader({ eyebrow, title, subtitle, className = "" }) {
  return (
    <div className={`max-w-2xl ${className}`}>
      {eyebrow ? (
        <p className="mb-3 text-xs font-medium uppercase tracking-[0.18em] text-accent">{eyebrow}</p>
      ) : null}
      <h2 className="text-2xl font-semibold tracking-normal text-primary sm:text-3xl">{title}</h2>
      {subtitle ? <p className="mt-3 text-sm leading-6 text-secondary sm:text-base">{subtitle}</p> : null}
    </div>
  );
}

export default SectionHeader;
